import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import { Container, Header, Icon, Anchor, Footnote } from 'Components/core';

import InfoBox from 'Components/InfoBox';

// Card
import CardContainer from 'Components/Card/CardContainer';
import Card from 'Components/Card';
import CardHighlighted from 'Components/Card/CardHighlighted';

// Icons
import wellness_desktop from './images/wellness_desktop.svg';
import wellness_phone from './images/wellness_phone.svg';
import alexa_icon from './images/alexa.png'

// Images
import healthyLiving from './images/Wellness_Resource_-_Healthy_Living.jpeg';
import workplacePerks from './images/Wellness_Resource_-_Workplace_perks.jpeg';
import incentivePrograms from './images/incentive-programs.jpg';
import contactUs from './images/contact-us.jpg';
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { SubHeader, TitleHeader } from 'Components/core/Header';

 

const renderFooter=(section)=>{
  if(section.footNotes && section.footNotes.length>0)
  {
    return (<Footnote>
      {section.footNotes.map(foot=>{
        return (<div dangerouslySetInnerHTML={{__html:foot.footnote}}></div>);
      })}
    </Footnote>);
  }
};

const getNewStyleData=state=>{
  return (<React.Fragment>  
    {state.wellness.resourcesMap.HealthyLiving.length>0 && (
      <InfoBox  image={healthyLiving} header="Healthy living">
        {state.wellness.resourcesMap.HealthyLiving.map(section=>{
          return (   <p>
            
            <b>{section.name}</b>
            <br />
            <div  dangerouslySetInnerHTML={{__html:replaceAnchor(section.summary)}} ></div>
            {displayHighLights(section.highlights)}
            {renderFooter(section)}
          </p>);
          
        })}
       
      </InfoBox>
    )}
    {state.wellness.resourcesMap.WorkplacePerks.length>0 && (
      <InfoBox  image={workplacePerks} header="Workplace perks">
        {state.wellness.resourcesMap.WorkplacePerks.map(section=>{
          return (   <p>
             
            <b>{section.name}</b>
            <br />
            <div  dangerouslySetInnerHTML={{__html:replaceAnchor(section.summary)}} ></div>
            {displayHighLights(section.highlights)}
            {renderFooter(section)}
          </p>);
        })}
       
      </InfoBox>
    )}
    {state.wellness.resourcesMap.IncentivePrograms.length>0 && (
      <InfoBox image={incentivePrograms} header="Incentive programs">
       
        {state.wellness.resourcesMap.IncentivePrograms.map(section=>{
          return (   <p>
            
            <b>{section.name}</b>
            <br />
            <div  dangerouslySetInnerHTML={{__html:replaceAnchor(section.summary)}} ></div>
            {displayHighLights(section.highlights)}
            {renderFooter(section)}
          </p>);
        })}
       
      </InfoBox>
    )}
  </React.Fragment>);
};




const displayHighLights=(highlights)=>{
  const bullets=highlights?.bullet
  if(bullets && bullets?.length>0)
  {
    return (<ul>
      {bullets.map(a=><li>{a}</li>)}
    </ul>)
  }
  return null;

}


/**
 * @deprecated
 */
const getOldStyleData=state=>{
  return (<React.Fragment> {(state.wellnessResources?.includeGymReimb ||
    state.wellnessResources?.includeHealthyLife ||
    state.wellnessResources?.includeMyHealthAdv ||
    state.wellnessResources?.includeMyHealthC ||
    state.wellnessResources?.includeOnlineKit ||
    state.wellnessResources?.includeSpecOffers ||
    state.wellnessResources?.includeStayHR ||
    state.wellnessResources?.includeWeightCenter ||
    state.wellnessResources?.includeWellBC) && (
    <InfoBox image={healthyLiving} header="Healthy living">
      <Container column seperation="16px">
        {state.wellnessResources?.includeGymReimb == true && (
          <div>
            <p>
              <b>Gym Reimbursement</b>
            </p>
            <p>
              Working out regularly? Ready to get started? This benefit
              helps pay for part of your gym dues.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeHealthyLife == true && (
          <div>
            <p>
              <b>Healthy Lifestyles</b>
            </p>
            <p>
              This total wellness program helps you break health goals
              into small steps, making it easier to reach those goals.
              You’ll get a personalized plan with online coaching and
              custom fitness trackers that help you manage your physical
              and mental health.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeMyHealthAdv && (
          <div>
            <p>
              <b>MyHealth Advantage</b>
            </p>
            <p>
              This free service helps you stay healthy and save money.
              You’ll get reminders when you need to refill a prescription
              or get a checkup, test or exam. You’ll also get a
              personalized and confidential MyHealth Note in the mail or
              on your mobile app if we see something that can help you.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeMyHealthC == true && (
          <div>
            <p>
              <b>MyHealth Coach</b>
            </p>
            <p>
              You and your family can get one-on-one professional advice
              from an experienced health coach. Talk to a coach for
              general wellness information, help with medicines or even
              more serious issues — like coping with an ongoing illness.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeOnlineKit == true && (
          <div>
            <p>
              <b>Online Wellness Toolkit</b>
            </p>
            <p>
              Get tools that help you set and achieve your unique health
              goals. It includes a Health Assessment, personalized
              trackers to monitor your progress toward reaching your goals
              and fun activities that promote healthier decisions.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeSpecOffers == true && (
          <div>
            <p>
              <b>SpecialOffers</b>
            </p>
            <p>
              Saving money is good. Saving money on things that are good
              for you — even better. With SpecialOffers, you can get
              discounts on products and services that help promote better
              health and well-being.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeStayHR == true && (
          <div>
            <p>
              <b>Staying Healthy Reminder</b>
            </p>
            <p>
              This yearly reminder tells you about important preventive
              health screenings or treatments you may need, based on your
              age and gender. You can get the reminder electronically or
              by mail. Make your selection on{' '}
              <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                {state.brandInfo.website}
              </Anchor>
              .
            </p>
          </div>
        )}

        {state.wellnessResources?.includeWeightCenter == true && (
          <div>
            <p>
              <b>The Weight Center</b>
            </p>
            <p>
              This online resource connects you to information on how to
              manage your weight, eat healthier and take care of your
              emotional well-being. It includes access to helpful tools
              like a body mass index (BMI) calculator, the Weight
              Management Playbook and FitLife podcasts at no extra cost to
              you.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeWellBC && (
          <div>
            <p>
              <b>Well-being Coach</b>
            </p>
            <p>
              A well-being coach provides practical tips and tailored
              support to help you achieve your goals like quitting tobacco
              or losing weight — at no extra cost to you. Call
              1-833-985-8464 or use your mobile app if you have a quick
              health question or want to start working on your individual
              health goals.
            </p>
          </div>
        )}
      </Container>
    </InfoBox>
  )}

  {(state.wellnessResources?.includeCommuter ||
    state.wellnessResources?.includeEAP ||
    state.wellnessResources?.includeProdSolutions ||
    state.wellnessResources?.includeWorkLife ||
    state.wellnessResources?.includeWorkSiteWellness ||
    state.wellnessResources?.includeWorkPlacePackage 
    
  ) && (
    <InfoBox image={workplacePerks} header="Workplace perks">
      <Container column seperation="16px">
        {state.wellnessResources?.includeCommuter && (
          <div>
            <p>
              <b>Commuter Benefits</b>
            </p>
            <p>
              Commuter benefits allow you to put tax-free money toward
              bus, subway or parking fees. You choose how much to deduct
              from your paycheck. Ask your employer for more detials and
              how to enroll.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeEAP && (
          <div>
            {' '}
            <p>
              <b>Employee Assistance Program (EAP)</b>
            </p>
            <p>
              If you’re having a hard time and aren’t sure where to turn,
              you can work with caring staff to help solve your problems.
              Your EAP is ready, whether it’s a family concern, a work
              situation or a financial question. You can find the EAP
              phone number on your member ID card.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeProdSolutions && (
          <div>
            <p>
              <b>Productivity Solutions</b>
            </p>
            <p>
              When you’re dealing with major health changes in your life,
              you may need support and guidance to get back on your feet.
              A coach works with you, your case manager, clinical experts
              and others to help you get your disability benefits, prepare
              for a hospital stay, cope with recovery and get job-related
              rehabilitation so you can stay at work or return sooner.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeWorkPlacePackage && (
          <div>
            <p>
              <b>{state.wellnessResources.includeWorkPlacePackage}</b>
            </p>
            {"Be Active"==state.wellnessResources?.includeWorkPlacePackage && <div>
              <p>
Earn up to $1,200 in Health Rewards <br/>
Get rewarded by participating in our preventative care and maternity activities. For complete details, visit the Health & Wellness Center on our website.

              </p>
              <p>
Gym Membership - up to $4001<br/>
Visit the gym a minimum of 35 times/6 months - $200 (twice annually).
              </p>

              <p>
Tobacco–free Certification - $502 <br/>
For not using tobacco products during the previous six months.
              </p>

              <p>
Well-being Coach - up to $3003<br/>
Lose weight or quit tobacco. $100 for participating in program and $200 for completing program.<br/>
– OR –<br/>
ConditionCare - up to $3003<br/>
Help for high-risk conditions. $100 for participating in program and $200 for completing program.
              </p>

              <p>
Future Moms - up to $200<br/>
$100 for completing initial assessment by 183 days before due date and $50 for completing interim assessment and $50 for completing post-birth assessment
              </p>

              <p>
Flu Shot + Wellness Visit - $1004 <br/>
For receiving both a preventive wellness exam and flu shot based on claims.
              </p>

              <p>
My Health Rewards Activities - $150 <br/>
Register on the app to complete a health assessment and track health activities.
              </p>

              <Footnote>* Anthem Health Rewards eligibility applies to only employees and their spouse/domestic partner. Member must be active on the plan and activity must take place during the plan effective year. 1. Proof of gym membership and fees required. 2. To earn the tobacco-free certification reward, an employee must log in to <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                {state.brandInfo.website}
              </Anchor> and certify they are tobacco-free. 3. Eligible members can participate in one program per year. Member can achieve either the Well-being Coach incentive or the ConditionCare incentive. 4. Rewards will show in account when the provider submits claims to Anthem after the employee receives their annual preventive wellness exam and flu shot.
              </Footnote>

            </div>}
            {"Take Charge"==state.wellnessResources?.includeWorkPlacePackage && <div>
              <p>
Earn up to $800 in Health Rewards <br/>
Get rewarded by participating in our preventative care and maternity activities. For complete details, visit the Health & Wellness Center on our website.
              </p>
              <p>

Tobacco–free Certification - $502 <br/>
For not using tobacco products during the previous six months.
              </p>

              <p>
Well-being Coach - up to $3003 <br/>
Lose weight or quit tobacco. $100 for participating in program and $200 for completing program.
                <br/>
– OR – <br/>
ConditionCare - up to $3003 <br/>
Help for high-risk conditions. $100 for participating in program and $200 for completing program. <br/>
              </p>

              <p>
Future Moms - up to $200 <br/>
$100 for completing initial assessment by 183 days before due date and $50 for completing interim assessment and $50 for completing post-birth assessment
              </p>

              <p>
Flu Shot + Wellness Visit - $1004 <br/>
For receiving both a preventive wellness exam and flu shot based on claims.
              </p>

              <p>
My Health Rewards Activities - $150  
Register on the app to complete a health assessment and track health activities.
              </p>

              <Footnote> * Anthem Health Rewards eligibility applies to only employees and their spouse/domestic partner. Member must be active on the plan and activity must take place during the plan effective year. 2. To earn the tobacco-free certification reward, an employee must log in to <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                {state.brandInfo.website}
              </Anchor> and certify they are tobacco-free. 3. Eligible members can participate in one program per year. Member can achieve either the Well-being Coach incentive or the ConditionCare incentive. 4. Rewards will show in account when the provider submits claims to Anthem after the employee receives their annual preventive wellness exam and flu shot.
              </Footnote>

            </div>}
            {"Get Control"==state.wellnessResources?.includeWorkPlacePackage && <div>

              <p>
Earn up to $600 in Health Rewards <br/>
Get rewarded by participating in our preventative care and maternity activities. For complete details, visit the Health & Wellness Center on our website.
              </p>
              <p>
Tobacco–free Certification - $502 <br/>
For not using tobacco products during the previous six months.
              </p>

              <p>
Well-being Coach - up to $3003<br/>
Lose weight or quit tobacco. $100 for participating in program and $200 for completing program.<br/>
– OR –<br/>
ConditionCare - up to $3003<br/>
Help for high-risk conditions. $100 for participating in program and $200 for completing program.
              </p>

              <p>
Future Moms - up to $200<br/>
$100 for completing initial assessment by 183 days before due date and $50 for completing interim assessment and $50 for completing post-birth assessment
              </p>

              <p>
Health Assessment - $50 <br/>
Take an online health assessment and answer questions about lifestyle, current health and health history.

              </p>

              <Footnote>* Anthem Health Rewards eligibility applies to only employees and their spouse/domestic partner. Member must be active on the plan and activity must take place during the plan effective year. 2. To earn the tobacco-free certification reward, an employee must log in to <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                {state.brandInfo.website}
              </Anchor> and certify they are tobacco-free. 3. Eligible members can participate in one program per year. Member can achieve either the Well-being Coach incentive or the ConditionCare incentive.
              </Footnote>
            </div>}
            {"Get Strong"==state.wellnessResources?.includeWorkPlacePackage && <div>
              <p>
             
Earn up to $200 in Health Rewards <br/>
Get rewarded by participating in our preventative care activities. For complete details, visit the Health & Wellness Center on our website.

              </p>
              <p>
Tobacco–free Certification - $502 <br/>
For not using tobacco products during the previous six months.
              </p>

              <p>
Flu Shot + Wellness Visit - $1004 <br/>
For receiving both a preventive wellness exam and flu shot based on claims.
              </p>

              <p>
Health Assessment - $50 <br/>
Take an online health assessment and answer questions about lifestyle, current health and health history.
              </p>

              <Footnote>* Anthem Health Rewards eligibility applies to only employees and their spouse/domestic partner. Member must be active on the plan and activity must take place during the plan effective year. 2. To earn the tobacco-free certification reward, an employee must log in to <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                {state.brandInfo.website}
              </Anchor> and certify they are tobacco-free. 4. Rewards will show in account when the provider submits claims to Anthem after the employee receives their annual preventive wellness exam and flu shot.</Footnote>

            </div>}
          </div>
        )}

        {state.wellnessResources?.includeWorkLife && (
          <div>
            <p>
              <b>Work-Life Solutions</b>
            </p>
            <p>
              Sometimes life takes you in unexpected directions and you’re
              faced with personal, money, legal or family issues. When
              this happens and you’re not sure what to do, Work-Life
              Solutions is here to support you with the right resources
              and programs. This confidential service is available 24/7 at
              no extra cost. To learn more, call the Member Services
              number on your ID card.
            </p>
          </div>
        )}

        {state.wellnessResource?.includeWorkSiteWellness && (
          <div>
            <p>
              <b>Worksite Wellness</b>
            </p>
            <p>
              Take advantage of convenient on-site health services such as
              body mass index (BMI) screenings, flu shots, massage
              treatments and health seminars. Check with your employer for
              event dates and details.
            </p>
          </div>
        )}
      </Container>
    </InfoBox>
  )}

  {(state.wellnessResources?.includeAntHRwrd ||
    state.wellnessResources?.includeWellBPerks) && (
    <InfoBox image={incentivePrograms} header="Incentive programs">
      <Container column seperation="16px">
        {state.wellnessResources?.includeAntHRwrd && (
          <div>
            <p>
              <b>Anthem Health Rewards</b>
            </p>
            <p>
              Get rewarded for living healthier every day. It can be as
              simple as getting preventive care or taking a class on
              healthy eating. You earn rewards when you complete the
              programs and activities. Check with your Benefits
              Administrator for more details.
            </p>
          </div>
        )}

        {state.wellnessResources?.includeWellBPerks && (
          <div>
            {' '}
            <p>
              <b>Well-being Perks</b>
            </p>
            <p>
              When you and your covered spouse or partner complete a few
              healthy steps, you can earn up to $350 per year in gift card
              rewards:
            </p>
            <ul>
              <li>
                $200 in gift cards for getting a preventive wellness exam
                and flu shot
              </li>
              <li>
                $50 gift card for completing an online health assessment
              </li>
              <li>$50 gift card for certifying you're tobacco-free</li>
              <li>$50 gift card for getting a dental exam</li>
            </ul>
          </div>
        )}

        {false && (
          <CardHighlighted column seperation="24px">
            <Header>Better Health Blog</Header>
            <p>
              Want healthy advice? Follow our Better Care Blog for helpful
              information about health benefits, living healthy and the
              latest member news.
            </p>
          </CardHighlighted>
        )}
      </Container>
    </InfoBox>
  )}
  </React.Fragment>);
};

export default () => {
  
  useEffect(()=>{
    Api.recordAcitity(CODES.MENU_WELL_RES);

  },[]);
  return (
    <Subscribe to={[ApiStore]}>
      {state => (
        <Container
          seperation="24px"
          column
          maxWidth
          style={{ margin: 'auto', padding: '32px' }}
        >
          <TitleHeader>Wellness 
              <SubHeader>Resources</SubHeader>

          </TitleHeader>
          <p>
          Take charge of your health and well-being with programs and tools that
          can help you live a healthier life.
          </p>
          <CardContainer>
            <Card column>
              <div>
                <img src={wellness_phone} style={{ width: '4em' }} />
              </div>
              <p>
              Use your ID card right from your phone. Your digital ID card is
              always current, always accurate and always with you. It works just
              like a paper one and it's easy to share with your doctor or
              pharmacy. Simply download the  <b>{state.mobileAppInfo?.appName}</b> mobile app or
              register at{' '}
                <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                  {state.brandInfo.website}
                </Anchor>
              .
              </p>
            </Card>
            <Card column>
              <div>
                <img src={wellness_desktop} style={{ width: '4em' }} />
              </div>
              <p>
              Register for online tools and resources. It's easy to get your
              health plan details on your mobile phone or computer. Simply
              download the  <b>{state.mobileAppInfo?.appName}</b> mobile app or register at{' '}
                <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                  {state.brandInfo.website}
                </Anchor>
              . You'll be able to find a doctor, estimate costs before you go,
              check your benefits, view claims, and more.
              </p>
            </Card>

            {state.appAlexa!='' && <Card column>
              <div>
                <img src={alexa_icon} style={{ width: '4em' }} />
              </div>
              <p style={{textAlign:'left'}}  dangerouslySetInnerHTML={{__html:replaceAnchor(state.appAlexa)}}>
           
              </p>
            </Card>}
          </CardContainer>
          {state.wellness?.resourcesMap==null && getOldStyleData(state)}
          {state.wellness?.resourcesMap && getNewStyleData(state)}
          {(state.contactUs?.associatesContent ||
          state.contactUs?.getAnswers) && (
            <InfoBox image={contactUs} header="Additional Information">
              <Container column seperation="16px">
                {state.contactUs?.associatesContent === 'HG1' && (
                  <p>
                    {state.brandInfo.name} Health Guides are here to help you get
                  the most out of your medical plan. These highly trained{' '}
                    {state.brandInfo.name} associates will help you with all your
                  health care needs. Reach a health guide by calling the number
                  on your member ID card. You also can go to{' '}
                    <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                      {state.brandInfo.website}
                    </Anchor>{' '}
                  to send a secure email or chat with them online.
                  </p>
                )}
                {state.contactUs?.associatesContent === 'HG2' && (
                  <p>
                    {state.brandInfo.name} Health Guides are here to help you get
                  the most out of your medical plan. These highly trained{' '}
                    {state.brandInfo.name} associates will help you with all your
                  health care needs. Reach a health guide by calling the number
                  on your member ID card. You also can go to{' '}
                    <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                      {state.brandInfo.website}
                    </Anchor>{' '}
                  to send a secure email.
                  </p>
                )}
                {state.contactUs?.associatesContent == 'HG3' && (
                  <p>
                    {state.brandInfo.name} Health Guides are here to help you get
                  the most out of your medical plan. These highly trained{' '}
                    {state.brandInfo.name} associates will help you with all your
                  health care needs.
                  </p>
                )}

                {state.contactUs?.getAnswers && (
                  <p>
                  If you have questions, it’s easy to get answers. Call the
                  Member Services number on the back of your ID card or use
                  online Message Center at{' '}
                    <Anchor code={CODES.WELL_RES_WEB} to={state.brandInfo.webLink}>
                      {state.brandInfo.website}
                    </Anchor>{' '}
                  or on your mobile app.
                  </p>
                )}
              </Container>
            </InfoBox>
          )}
        </Container>
      )}
    </Subscribe>
  );
};